import { render } from "./CompareView.vue?vue&type=template&id=9dd0b350&scoped=true&ts=true"
import script from "./CompareView.vue?vue&type=script&lang=ts"
export * from "./CompareView.vue?vue&type=script&lang=ts"

import "./CompareView.vue?vue&type=style&index=0&id=9dd0b350&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dd0b350"]])

export default __exports__